<template>
	<v-container fluid>
		<v-row dense>
			<!-- search -->
			<v-col cols = "12">
				<v-card outlined>
					<v-card-title class = "secondary pa-0  px-1 body-1 black--text">	
						
						
						<v-icon 
							small 
							color  = "white"
							class  = "ml-1"
							@click = "$router.back()"
						>
							mdi-arrow-left-circle
						</v-icon>
						<v-spacer></v-spacer>
						<v-icon 
							small
							color  = "success"
							class  = "mx-1"
							@click = "$router.back()"
						>
							mdi-chart-bar-stacked
						</v-icon>
						<strong
							class = "white--text text-uppercase"
						>
							
							{{ $ml.get('reports') }}
						</strong>
						<v-chip
						  	label
						  	x-small						  	
						  	color = "primary"
						  	class = "mx-1 text-uppercase"
						>
							{{ render_title }}
						</v-chip>
						<v-spacer></v-spacer>
					</v-card-title>
					<v-card-text
						class = "pa-1 mt-1"
					>
						
						<v-row
							dense
						>
							<v-col
								:cols = "'auto'"
								v-show = "show.type_search"
								class = "mx-1"
							>
								

								<v-btn									
									:color = "type_search.color"
									@click = "actions('change_alarms_smart')"
									class  = "secondary--text"

								>
									{{ $ml.get(type_search.type) }}
									<v-icon
										
										class = "ml-1"
									>
										mdi-gesture-tap
									</v-icon>
								</v-btn>
							</v-col>
							<template
								v-for = "(item_search, idx_search) of info_search_fields"
							>
								<v-col
									:key  = "idx_search"
									:cols = "item_search.cols.col"
									v-if  = "item_search.visible"
									v-show 		= "show[item_search.key]"

								>
									<v-select
										v-if 		= "item_search.type == 'select'"
										dense
										outlined
										hide-details
										:items 	  	 = "render_listed(item_search.list)"
										:label       = "$ml.get(item_search.text)"
										v-model  	 = "info_search[item_search.key]"
										:item-value	 = "item_search.key_list"
										:item-text 	 = "item_search.text_list"
										:placeholder = "$ml.get(item_search.placeholder)"
										:multiple	 = "item_search.multiple"
										v-show 		 = "show[item_search.key]"
									>
										<!-- @input 		 = "render_action_choise(item_search, $event)" -->
										
									</v-select>
										<!-- @input 		 = "render_analytic_option(item_search.key, info_search[item_search.key])" -->
									<!-- get_list();  -->
									<searcher
										v-if 			   = "item_search.type == 'select_searcher'"
										:info_to_component = "item_search"
										:clear_value       = "render_title"
										:info_to_list  	   = "render_listed(item_search.list)"
										@receive_info	   = "info_search[item_search.key] = $event"
										v-show 		 	   = "show[item_search.key]"
										:isSelectAll 	   ="item_search.isSelectAll"
									></searcher>
									<dates
										v-if 			   = "	item_search.type == 'date_range' 	|| 
																item_search.type == 'time_picker'"
										:info_to_component = "item_search"
										:info_to_dates 	   = "render_listed(item_search.list)"
										@receive_info	   = "info_search[item_search.key] = $event"
										v-show 			   = "show[item_search.key]"
									></dates>

									<v-text-field
										dense
										outlined
										hide-details 
										v-model 		= "info_search[item_search.key]"
										:label       	= "$ml.get(item_search.text)"
										:type 			= "item_search.type"
										v-if 			= "item_search.type == 'text' || item_search.type == 'number'"
										@input 			= "v => { info_search[item_search.key] = v.toUpperCase(), info_search[item_search.key] = info_search[item_search.key]}" 
										@keyup.enter    = "get_list(true)" 
										@click 			= "$Helper.keyboard_is_active(item_search.key, ID_notification,'obj','info_search')"
										class 			= "text-uppercase"
										v-show 		 	= "show[item_search.key]"
									></v-text-field>
									<v-file-input
										dense
									    outlined
									    :multiple 	= "item_search.multiple"
									    v-if 		= "item_search.type == 'file'"
									    :label  	= "item_search.text"
									    v-model 	= "info_search[item_search.key]"
									    @change 	= "image_to_b64(info_search[item_search.key], item_search)"
										v-show 		= "show[item_search.key]"
									></v-file-input>									
								    <v-btn
								    	v-if 	= "item_search.type == 'btn'"
								    	@click 	= "actions(item_search.action)"
								    	:color  = "item_search.color"
								    	v-text  = "$ml.get(item_search.text)"
								    ></v-btn>
								</v-col>
							</template>
						</v-row>
						<v-progress-linear
							indeterminate
							color  = "primary"
							v-show = "loading" 
						></v-progress-linear>

						<input 
							type 	= "" 
							name 	= ""
		                 	@input 	= "onInputChange"
		                  	:value 	= "input"
		                  	class 	= "input"
		                  	v-show 	= "false"
		                >
		         
		                    <!-- <v-bottom-sheet 
		                    	v-model = "sheet" 
		                    	inset
		                    >

			                  	<v-sheet 
			                  		height = "300px" 
			                  		class  = "pa-1"
			                  	>
	                              	<SimpleKeyboard 
	                                	@onChange 	= "onChange" 
	                                	@onKeyPress = "onKeyPress" 
	                                	:input 		= "info.plate_char" 
	                                	:theme 		= "theme"
	                              	/>
			                  	</v-sheet>
		                	</v-bottom-sheet>   -->
					</v-card-text>
				</v-card>
			</v-col>
			
			
			<!-- list playback -->
			<v-col cols = "12">
				<v-card outlined>
					<v-card-text>
						<!-- <events 
				          	:report_list 	  = "report_items"
				          	:total_report 	  = "total"
				          	:is_reports 	  = "true"
				          	:ref_to_component = "'lpr'"
				          	@options_report   = "options = $event"
				        ></events> -->
				        <v-data-table
							dense
						    :headers 			 = "headers"
						 	:items 	 			 = "list_render"
						    class 	 			 = "elevation-5"			    
						    :hide-default-footer = "height < 56 ?  true : false"
						   	:options.sync 		 = "options"
						   	:server-items-length = "total"
						   	:footer-props 		 = "{
						   		showFirstLastPage   : true,
						   		itemsPerPageOptions : [30],
						   		showCurrentPage     : true
						   	}"
						   	loading-text 		= "Loading... Please wait"
						    :height 			= "height + 'px'"
						    item-key 			= "index"
						    :loading 			= "loading"
						    fixed-header
						>

							<!-- <template v-show="loading" v-slot:progress>
							    <v-progress-linear 
							    	color="primary" 
							    	:height="10" 
							    	indeterminate
							    ></v-progress-linear>
							 </template> -->

						   <template 
						   		v-if = "list_render == null " 
						   		v-slot:no-data
						   	>
						      	NO DATA HERE!
						   </template>

						   
						    <!-- v-for="item in list_render_off.slice().reverse()" :key="item.id" v-if="render_hostname(item.host)" -->
						    <template v-slot:item.img = "{ item }">
						    	<div 
						    		class  = "pa-0 ma-0 d-flex"  
						    		@click = "send(item)" 
						    	>							 
						    		<!-- max-width="80px;" -->
									<v-img 
										:src   = "item.img"  
										@error = "item.img = '/img/no_img_found.png'"
										height = "25px" 
										style  = "width : 80px"				
										contain
									/>
						
								</div>	
						    </template>


						    <template v-slot:item.plate_chars = "{ item }">
						    	<v-chip  
						    		small
						    		label			    		
						    		class = "text-uppercase font-weight-bold"
						    	>
						    		{{ item.plate_chars }}
						    	</v-chip>
						    </template>

						    <template v-slot:item.tags_colors = "{ item }">
						    	<template 
						    		v-for = "(item_tag, indx_tag) of item.tags_colors "
						    	>
						    		<v-badge
									  bottom
									  overlap									  
									  :content = "item_tag.count"
									>
										
								    	<v-chip 
								    		small
								    		:color = "item_tag.color"
								    	>	
								    		{{ item_tag.tag }}	
								    	</v-chip>			    	
									</v-badge>
						    	</template>
						    </template>	
						    <template v-slot:item.tag = "{ item }">		
						    	<v-chip 
						    		small
						    		:color = "item.color_tag"
						    	>	
						    		{{ item.tag }}	
						    	</v-chip>	
						    </template>
						     <template v-slot:item.entry = "{ item }">		                   
		                        <v-img 
		                            :src        = "$Helper.check_img(item.entry_full_photo, $URL)"  
		                            :lazy-src   = "$Helper.check_img(item.entry_full_photo, $URL)" 
		                            @error      = "item.entry_full_photo = '/img/no_img_found.png'"
		                            height      = "35px" 
		                            style       = "width : 120px; "            
		                            class       = "pa-0 ma-0" 
		                        ></v-img>
		                       
		                        <v-chip
		                            x-small
		                            label
		                        >   
		                            {{ item.entry_device_name }}
		                        </v-chip>
		                        <v-chip
		                            x-small
		                            label
		                        >                            
		                            {{ item.entry_event_type }} 
		                        </v-chip>
		                        <br>
		                        <span
		                            style = "font-size: 70%; line-height: 30%"
		                        >            
		                            {{ item.entry_date }} 
		                        </span>
		               	 	</template>
		                	<template v-slot:item.exit = "{ item }">
		                        <v-img 
		                            contain
		                            :src        = "$Helper.check_img(item.exit_full_photo, $URL)"  
		                            :lazy-src   = "$Helper.check_img(item.exit_full_photo, $URL)" 
		                            @error      = "item.exit_full_photo = '/img/no_img_found.png'"
		                            height      = "35px" 
		                            style       = "width : 120px"             
		                        ></v-img>
		                        
		                        <v-chip
		                            x-small
		                            label
		                        >                            
		                            {{ item.exit_device_name }} 
		                        </v-chip>
		                        <v-chip
		                            x-small
		                            label
		                        >                            
		                            {{ item.exit_event_type }} 
		                        </v-chip>
		                        <br>
		                        <span
		                            class = "pa-0"
		                            style = "font-size: 70%; line-height: 30%"
		                        >
		                            {{ item.exit_date }} 
		                            
		                        </span>
		                
		                	</template>
			                <template v-slot:item.information = "{ item }">
			                    <span >
			                        {{ $ml.get('plate')  }}  : 
			                        <v-chip 
			                            label                       
			                            x-small
			                            class   = "text-uppercase font-weight-bold"
			                            color   = "secondary"
			                        >
			                            {{ item.plate }} 
			                        </v-chip>
			                        <br>
			                        {{ $ml.get('barcode') }} : {{ item.barcode }} <br>
			                    </span>
			                    
			                </template>
			                <template v-slot:item.status = "{ item }">
			                    <v-chip 
			                        x-small
			                        :color = "item.status_color_parked"
			                    >
			                        {{ item.status_parked }}
			                    </v-chip><br>
			                    <span
			                        style = "font-size: 70%; line-height: 60%"
			                    >
			                        
			                        {{  item.parked_time }}
			                    </span>
			                </template>
			                <template v-slot:item.invoice = "{ item }">
			                    <v-btn
			                        small
			                        color  = "primary"
			                        @click = "send(item)"
			                    >
			                        <v-icon
			                            small
			                        >
			                            mdi-view-list
			                        </v-icon>
			                    </v-btn>
			                </template>
			                <template
			                	v-for 	= "(item_slot, idx_slot) of list_slots" 
			                	v-slot:[`item.${item_slot.slot}`] = "{ item , index}" 
			                >
			                	<v-chip 

			                        label
			                        x-small
			                        :key   = "ref + idx_slot + 'chip_slot' + index"
			                        :color = "item[item_slot.key_color]"
			                    >
			                        {{ item[item_slot.slot] }}
			                    </v-chip>			                   
			                </template>	  
						    <template v-slot:item.attributes = "{ item }">
						    	<v-chip 
						    		small
						    		label
						    		class = "ma-1"
						    		v-for = "(attr, index) in item.attributes"
						    		:key = "index"
						    	>
						    		{{ attr.type }}: {{ attr.classname }}
						    		<v-tooltip bottom>
						    			<template v-slot:activator="{ on, attrs }">
						    				<v-icon
						    					small
						    					class = "ml-1"
						    					v-bind = "attrs"
						    					v-on = "on"
						    				>
						    					mdi-information
						    				</v-icon>
						    			</template>
						    			<span>Probability: {{ (attr.probability * 100).toFixed(2) }}%</span>
						    		</v-tooltip>
						    	</v-chip>
						    </template>
						</v-data-table>
					</v-card-text>
					<v-divider></v-divider>
			        <v-card-actions>
			          	<DownloadExcel 
			          		v-show = "!loading_export && show.export" 
			          		:type_search = "type_search"
			          		:list_smart_events = "list_smart_events"
			          		:info_search = "info_search"
			          		:reference = "ref"
			          		@receiveLoading = "loading_export=$event"
			          	></DownloadExcel>
			          		
			          	
			          	<v-spacer></v-spacer>

			          	<h5> <strong>{{ message_export }} </strong></h5>
			          	<v-spacer></v-spacer>
			          	<v-tooltip top>
			          		<template v-slot:activator="{ on }">
			          			
					          	<v-btn 
					          		small 
					          		color  = "primary" 
					          		class  = "mx-2"
					          		@click = "exportExcelAll" 
					          		v-text = "$ml.get('export_all')" 
					          		v-show = "!loading_export && show.exportAll"
					          		v-on   = "on"   
					          	></v-btn>  
			          		</template>
			          		<span>
			          			{{$ml.get('option_to_export') }} <br>
			          			<strong class="warning--text">{{ $ml.get('warning_more_time')}}</strong>
			          		</span>
			          	</v-tooltip>
			          	<v-progress-circular
			                indeterminate
			                color 	= "primary"
			                v-show 	= "loading_export"
			            ></v-progress-circular>
			        </v-card-actions>
					
				</v-card>
			</v-col>

		</v-row>
		<alert 
		    :key				= "'events_modal_report'"
            :ref_to_component   = "'events_' + ref"
		    :info_to_component  = "info_to_modal"
			type 				= "modal"
			:is_sound 			= "false"
		    @close				= "close_modal($event)"
		/>
	</v-container>
</template>
<script>
	import searcher 		from "@/components/info/searcher.vue"
	// import XLSX 			from 'xlsx'
	// import events 			from '@/components/events/events.vue'
	import SimpleKeyboard 	from "@/components/simple_Keyboard.vue";
	import dates 			from "@/components/info/dates.vue"
  	import format           from '@/class/formats'
	import alert 	 		from '@/components/info/alert.vue';
	import EventBus 		from '@/event-bus'
	import DownloadExcel from "@/components/reports/DownloadExcel.vue"
	export default{
		name 		: 'Reports',
		// extends: Line,

		components  : {
			searcher,	    
			// events, 
			SimpleKeyboard,
			dates,
			alert,
			DownloadExcel,
			// GChart
			// LineChart,
			// events
		}, // components
		data : (vm) => ({
			info 				: {},
			info_search 		: {
				start : "00:00",
				end   : "23:59",
				tags  : [], 
				deviceId : [],
				traineds : [],
				speed : null,
			},
			info_to_modal 		: null,
			Format 				: null,
			info_search_fields 	: [
				{
					key 		: 'deviceId',
					text 		: 'device',
					placeholder : 'device',
					list 		: 'list_devices',
					key_list	: 'deviceId',
					text_list 	: 'name',
					type 		: 'select_searcher',
					key_search  : 'name',
					key_search_1 : 'deviceId',
					visible 	: true,
					multiple 	: true,
					isSelectAll : true,
					cols 		: {
						col : 2,
					},
				},
				/*{
					key 		: 'file',
					text 		: vm.$ml.get('file'),
					placeholder : 'file',
					// list 		: 'list_devices',
					// key_list	: 'deviceId',
					// text_list 	: 'name',
					type 		: 'file',
					// key_search  : 'name',
					// key_search_1 : 'deviceId',
					visible 	: true,
					multiple 	: false,
					cols 		: {
						col : 2,
					},
				},*/
				{
					key 		: 'tags',
					text 		: 'tag',
					placeholder : 'tag',
					list 		: 'list_smart_events',
					key_list	: 'id',
					text_list 	: 'name',
					type 		: 'select_searcher',
					key_search  : 'name',
					key_search_1 : 'tag',
					visible 	: true,
					multiple 	: true,
					isSelectAll : true,
					cols 		: {
						col : 2,
					},
				},
				{
					key 		: 'traineds',
					text 		: 'trained_faces',
					placeholder : 'trained_faces',
					list 		: 'list_traineds',
					key_list	: 'userId',
					text_list 	: 'userName',
					type 		: 'select_searcher',
					key_search  : 'userName',
					key_search_1 : 'userId',
					visible 	: true,
					multiple 	: true,
					isSelectAll : true,
					cols 		: {
						col : 2,
					},
				},
				{
					key 		: 'dates',
					text 		: 'date',
					placeholder : 'select',
					type 		: 'date_range',
					visible 	: true,
					cols 		: {
						col : 2,
					},
				},
				{
					key 		: 'start',
					menu 		: 'picker_start',
					ref 		: 'menu_start',
					text 		: 'Start',
					placeholder : 'time',
					type 		: 'time_picker',
					visible 	: true,
					cols 		: {
						col : 1,
					},
				},
				{
					key 		: 'end',
					menu 		: 'picker_end',
					ref 		: 'menu_end',
					text 		: 'End',
					placeholder : 'time',
					type 		: 'time_picker',
					visible 	: true,
					cols 		: {
						col : 1,
					},
				},
				{
					key  :  'search',
					text :  'search',
					type :  'text',
					visible 	 : true,					
					placeholder  : 'type a plate',
					ref_analytic : 'lpr',
					cols 		 : {
						col : 1,
					},

				},
				{
					key 		: 'speed',
					text 		: 'speed',
					placeholder : 'speed',
					type 		: 'number',
					visible 	: false,
					cols 		: {
						col : 1,
					},
				},
				{
					key 		: 'btn',
					action 		: 'search',					
					ref 		: 'search',
					text 		: 'search',
					placeholder : 'btn',
					type 		: 'btn',
					color 		: 'primary',
					visible 	: true,
					cols 		: {
						col : 1,
					},
				},


			],
			headers 		: [
				{ text: vm.$ml.get('device'), 	value: 'device'},
				{ text: vm.$ml.get('plate'), 	value: 'plate_chars'},
				{ text: vm.$ml.get('segment'), 	value: 'img', align: 'center',},
				{ text: vm.$ml.get('speed'), 	value: 'speed'},
				{ text: vm.$ml.get('speed_limit'), 	value: 'speed_limit'},
				{ text: vm.$ml.get('color'), 	value: 'color'},
				{ text: vm.$ml.get('type_vehicle'), 	value: 'type_vehicle'},
				{ text: vm.$ml.get('direction'), 	value: 'direction'},
				{ text: vm.$ml.get('attributes'), 	value: 'attributes'},
				{ text: vm.$ml.get('date'), 	value: 'date'},
			], // headers 
			list_devices 		: [],
			list_smart_events  	: vm.$SmartEvent.get(null, "list_smart_event", 'option_all'),
			list_traineds  		: [],
			ID_notification : 'reports',
			options 		: { itemsPerPage : 30 },
			total 			: 0,
			height 			: 400,
			loading 		: false,
			message 		: {
				msg     : '',
				success : false,
				error   : false,
			},
			input 			: '',
	      	theme 			: 'hg-theme-default myTheme1', // myTheme1
	      	sheet 			: false,
	      	report_items  	: [],
	      	loading_export  : false,
	      	message_export  : "",
	      	bus 			: {},
	      	ref 			: "",
	      	load_func 		: null,
	      	show 			: {
	      		export 		: true,
	      		deviceId 	: true,
				file 		: false,
				dates 		: true,
				start 		: true,
				end 		: true,
				search 		: true,
				btn 		: true,
				type_search : false,
				tags 		: true,
				traineds  	: false,
				speed 		: false,
	      	},
	      	type_search 	: {
	      		color 	: "warning",
	      		type 	: "alarms", // smart_event
	      	},
	      	list_slots : 	[
	      		{
	      			slot 		: "is_incident",
	      			key_color	: "color_incident",
	      			color  		: "secondary",
	      		},
	      		{
	      			slot 		: "is_confirmed",
	      			key_color	: "color_confirmed",
	      			color  		: "secondary",
	      		},
	      		{
	      			slot 		: "isignored",
	      			key_color	: "color_ignored",
	      			color  		: "secondary",
	      		},
	      		{
	      			slot 		: "false_positive",
	      			key_color	: "color_fp",
	      			color  		: "secondary",
	      		},
	      		{
	      			slot 		: "type_incident",
	      			key_color	: "color_type_incident",
	      			color  		: "secondary",
	      		},
	      	],	      	
		}), // data  

		watch:{
			options:{
		        handler(){
		          this.get_list();		       
		        },
		        deep: true,
		    }, //options
		}, // watch
		
		created(){
			// setting format		    
		    // set class to variable global
		    this.$Format.update_list('ml', this.$ml);
		    // console.log("FORMAT =======================", this.$Format);
		      
			if (localStorage.getItem('list_devices')) {
				this.list_devices = JSON.parse(localStorage.getItem('list_devices'));
			}
			this.get_traineds();
		}, // created

		computed : {

			list_render : function(){
				return this.report_items;

			}, // list render

			render_title : function(){
				let name = "reports"
				if (this.$route && this.$route.name) {
					let temp = this.$route.name.split("_");
					if (temp.length > 0) {
						name = temp[1];
					}else{
						name = this.$route.name;
					}
					this.render_created(name)
				}
				return name;
			}, // render title

		}, // computed

		methods : {

			actions(act, item, opt){
				switch (act){
					
					case ('search') : {
						this.get_list(true)
					}break;
					case ('change_alarms_smart'):{
						if (this.type_search.type == "alarms") {
							this.type_search.type  = "smart_event"; 
							this.type_search.color = "primary";

						}else{
							this.type_search.type = "alarms"; 
							this.type_search.color = "warning";

						}

					}
					break;
					default : {
						console.log("this option not exist ")
					}
				};
			}, // actions

			
			send(val){
				if (val && val.formated) {
					this.info_to_modal = val.formated;
				}
			}, // send

			image_to_b64(files, options){
				if (options ) {
					if (files) {						
						this.info_search.files = [];						
						// console.log("Convert b64 , ", files)
						if (options.multiple) {
							if (files && files.length > 0) {
								files.forEach(async (fil, idx_fil)=> {						
									if (fil) {
										this.$Helper.file_to_b64(fil).then(b64 => {
											// console.log("B64 : ", b64)
											if (b64) {

												this.info_search.files.push({
													b64    		: b64,
													key 		: idx_fil + 1
												})
											}
										})
									}
								}) 
							}

						}else{
							this.$Helper.file_to_b64(files).then(b64 => {							
								if (b64) {
									// console.log("converted ", b64)
									this.info_search.files.push({
										b64    		: b64,
										key 		: 1
									})
								}
							})
						}
					}else{
						console.warn("Required file to convert to b64 ", files)
						this.info_search.files = [];						
						
					}
				}
			}, // image to b54

			render_listed (list){
				if (list == 'list_devices') {
					this.list_devices  = this.$store.getters["Devices/list"];//_options
					return this.list_devices;
				}
				return this[list];
			}, // render listed

			render_created(name="alarms"){				
				this.ID_notification 		+= name;
				this.ref 			 	 	= name; 
				this.show.export 			= true;
				this.show.exportAll  		= false;
				this.show.file   			= false;
				this.show.tags 				= false;
				this.show.search 			= true;
				this.show.type_search 		= false;
				this.show.traineds 			= false;
				this.type_search.type		= "alarms";
				this.type_search.color 		= "warning";
				
				const indexTag  			= this.info_search_fields.findIndex(x => x && x.key == "tags") 
				if (indexTag >= 0) {
					this.info_search_fields[indexTag].visible = false; 
				}


				if (name == "avc") {
					this.headers 				= [
						{ text: this.$ml.get('device'), 	value: 'device'},
						{ text: this.$ml.get('vehicle_type'), 	value: 'tags_colors'},						
						{ text: this.$ml.get('axle_counter'), 	value: 'axle_counter'},
						{ text: this.$ml.get('evidence'), 	value: 'img', align: 'center',},
						{ text: this.$ml.get('date'), 	value: 'date'},
					];
				}else if(name == "parking"){
					this.headers = [
						{ text : this.$ml.get("information"), value : "information" },
						{ text : this.$ml.get("entry"), value : "entry" },
						{ text : this.$ml.get('exit'), 	value: 'exit', align: '' },										
						{ text : this.$ml.get("status"), value : "status" },				
						{ text : this.$ml.get("invoice"), value : "invoice" },	
					];
				}else if (name == "face") {
					this.headers = [
						{ text: this.$ml.get('device'), 			value: 'device', align: '' },
						{ text: this.$ml.get('tags'), 			value: 'tags_colors', 	align: '',},
						{ text: this.$ml.get('evidence'), 		value: 'img', align: 'center',},
						{ text: this.$ml.get('probability'), 		value: 'probability' },												
				 		{ text: this.$ml.get('date'), 			value: 'date', align: '',},
				 	];
				 	this.show.file   = true;
				 	this.show.export = true;
				 	this.show.traineds = true;
					this.show.search 			= false;

				}else if(name == "alarms"){

					this.headers = [
						// { text: vm.$ml.get('id'), 		value : 'id', align: 'center' },
						{ text : this.$ml.get('device'), 		value : 'device', align: '' },
						{ text : this.$ml.get('tag'), 		value : 'tags_colors', align: '' },
						{ text : this.$ml.get('evidence'), 	value : 'img', align: '' },
						{ text : this.$ml.get('speed'), 		value : 'speed', align: '' },
						{ text : this.$ml.get('probability'), value : 'probability' },						
						{ text : this.$ml.get('date'), 		value : 'date', align: '' },			
						{ text : this.$ml.get('type_incident'), value : 'type_incident', align: '' },

						// { text : this.$ml.get('is_incident'), value : 'is_incident', align: '' },
						// { text : this.$ml.get('confirmed_alert'), value : 'is_confirmed', align: '' },
						{ text : this.$ml.get('user'), 			value : 'user', align: '' },	
						{ text : this.$ml.get('action'), 			value : 'action_done', align: '' },	
						{ text : this.$ml.get('confirmed_date'), 	value : 'date1', align: '' },
						// { text : this.$ml.get('isignored'), 			value : 'isignored', align: '' },
						// { text : this.$ml.get('false_positive'), 	value : 'false_positive', align: '' },						


					];
					this.show.type_search 		= true;
					this.show.tags 				= true;					
					this.show.search 			= false;
					this.show.speed 			= true;
					this.show.exportAll 		= true;
					if (indexTag >= 0) {
						this.info_search_fields[indexTag].visible = true; 
					}

				}
				else{
					this.headers 				= [
						{ text: this.$ml.get('device'), 	value: 'device'},
						{ text: this.$ml.get('plate'), 	value: 'plate_chars'},
						{ text: this.$ml.get('segment'), 	value: 'img', align: 'center',},
						{ text: this.$ml.get('date'), 	value: 'date'},
					];
				}			
				this.info_search 			 = {
					start : "00:00",
					end   : "23:59",
					tags  : [],
					deviceId : [],
					traineds : [],
					speed : null,
				};
				this.report_items = [];			
			}, // render created			

			renderToExcel(items,ref){
				return new Promise((resolve, reject)=>{

					if (items && items.data && items.data.rows && items.data.rows.length > 0) {
						this.$Format.report_export_excel(ref, items.data.rows, null, this.$Format, (load) => {       		
				       		if (load && load.length > 0) {								
				       			resolve(load);
				       		}else{
				       			resolve([]);
				       		}
				       })		
					}else{
						resolve([]);
					}
				})
			}, // renderToExcel

		    get_list(v = false){

		      	if (this.info_search && this.info_search.deviceId) {
			      	let dates 		 	= this.info_search.dates;				
			      	let formated_dates 	= this.$Format.format_date_time(dates, this.info_search, true, false);
		    		let timeZone 		= this.$timezone;

		    		
			      	let info = {		        	
				        deviceId 	  : this.info_search.deviceId, //this.select_host,
				        start 		  : formated_dates.start,
				        end  		  : formated_dates.end,
				        files  		  : this.info_search.files,
				        timeZone,
			      	};			      	
			      	if (this.info_search.tags && this.info_search.tags.length > 0) {
			      		info.tags 		= [];
			      		info.rulesId 	= [];
			      		if (this.list_smart_events && this.list_smart_events.length > 0) {			      		
				      		this.list_smart_events.forEach(x => {
				      			if (x.id != 'all' && this.info_search.tags.includes(x.id)) {			      				
				      				info.tags.push(x.name);
				      				info.rulesId.push(x.id);
				      			}			      			
				      		});
			      		}
			      	}			        
			      	
			      	if (this.info_search.traineds && this.info_search.traineds.length > 0) {
			      		info.traineds = this.info_search.traineds;//.map(x => x.userId);
			      	}
			      	
			      	if (this.info_search.speed) {
			      		info.speed = this.info_search.speed;
			      	}
				    let pg = 1, sw = 0;
				    const  { page, itemsPerPage } = this.options;
			      	/* if (itemsPerPage == 15) {
			          	if (page % 2 == 0) {
			            	pg = (page / 2);
			            	sw = 2;
			         	}else{
			            	pg = parseInt(page / 2) + 1;
			            	sw = 1;
			          	}
			        }else{
			        }*/
			        pg=page
			        // console.log("PAGE ", pg)
				    this.loading 	= true;
				    let url_ 	 	= '/api/v1/lpr/find/?page=';
				    if (this.render_title == "avc") {				     	
				     	url_ 				= '/api/v1/avc/find/?page=';
				     	info.vehicle_type 	= this.info_search.search;
				    }else
				    if (this.render_title == "face") {
				    	url_ 				= '/api/v1/face/find/?page=';
				     	info.userName 		= this.info_search.search;

				    }else if (this.render_title == "alarms") {
			        	if (this.type_search.type == "alarms") {
			     			url_ 				= '/api/v1/alerts/find/?page=';		
			     		}else{
			     			url_ 				= '/api/v1/smart_event/find/?page=';		
			     		}
			    	}else{
				    	if (this.render_title == "parking") {
				     		url_ 				= '/api/v1/parking/find/?page=';
				    	}

				        info.plate_char 	= this.info_search.search;
				       
				    }

				    const api = this.$URL + url_ + pg ;//+'?limit='+itemsPerPage;
				      
				    this.$axios.post(api, info).then( res =>{
				        // console.log(res.data)
				        if (res && res.data) {

					        let items  	= res.data.rows
					        this.total 	= parseInt(res.data.count)
					        let msg 	= '';

					        // if (itemsPerPage <= 15) {
					        //   items = items.slice((sw - 1) * itemsPerPage, sw  + itemsPerPage );
					        // }
					        
					        let list_new = [];
					        if (items && items.length > 0) {

					            for(let j of items){
					            	let temp = this.$Format.format_info(j, this.ref, 'table');
					            	if (temp) {
					              		list_new.push(temp);
					            	}
					            }
						        this.report_items = list_new;
					        }else{
						        this.report_items = [];

					        }
					        
					      
					        // if (v && list_new) {
					        if (list_new.length == 0) {
					              	msg  = this.$ml.get('data_no_found');				              	
					        }else
					        if (res.data.page == '1') {
					        	this.$EventBus.$emit('notifications_modal',{
					        		type 	 : 'success',
					        		message  : this.$ml.get('data_found'),
					        	})
					        }	     				            
				        // }			      
				        }else{
				        	this.$EventBus.$emit('notifications_modal',{
				        		type 		: 'error',
				        		message  	: this.$ml.get('data_no_found'), //'Not response data'
				        	})
				        }
				        this.loading = false;
				    }).catch( er => {
				        console.log(er.response, 'error reports')
				        let msg = this.$ml.get('data_no_found'); // er.response.data.msg			        				       
				        /*if (er && er.message) {
				        	msg = er.message;
				        }*/
				        this.$EventBus.$emit('notifications_modal', {
		      				type 	: 'error',
		      				message : er
		      			});
				        this.loading = false;

				    });
		      	}else{
		      		console.log("Not found device to search");
		      		this.$EventBus.$emit('notifications_modal', {
		      			type 	: 'warning',
		      			message : this.$ml.get('req_sel_device'),
		      		});
		      	}
		    }, // get list

		    get_traineds(){		    	
		    	this.$axios.get(this.$URL + "/api/v1/face/trained/all").then(res =>{
		    		if (res && res.data && res.data.rows && res.data.rows.length > 0) {
		    			this.list_traineds = res.data.rows;
		    			// this.list_traineds.unshift({ id : "all", userName : "all" , userId : "all"});
		    		}
		    	}).catch(err => {
		    		console.warn("Error get traineds ", err);
		    	})
		    }, // get traineds

		    close_modal(item){
				this.info_to_modal = null;
			}, // close modal

		    

		    async exportExcelAll(){
		    	try{
		    		if (this.info_search && this.info_search.deviceId) {
			    		this.loading_export = true;
			    		this.message_export = this.$ml.get("preparing_to_export");
				        let dates 		 	= this.info_search.dates;			
						let formated_dates 	= this.$Format.format_date_time(dates, this.info_search, true, false);
			    		let timeZone 		= this.$timezone;

					    let info 			= {		        	
					        deviceId 	  : this.info_search.deviceId, //.map(x => x.deviceId), //this.select_host,				        
					        start 		  : formated_dates.start,
					        end  		  : formated_dates.end,
					        timeZone,

					    };
			    		if (this.info_search.tags && this.info_search.tags.length > 0) {
				      		info.tags 		= [];
				      		info.rulesId 	= [];
				      		if (this.list_smart_events && this.list_smart_events.length > 0) {			      		
					      		this.list_smart_events.forEach(x => {
					      			if (x.id != 'all' && this.info_search.tags.includes(x.id)) {			      				
					      				info.tags.push(x.name);
					      				info.rulesId.push(x.id);
					      			}			      			
					      		});
				      		}
				      	}
			    		if (this.info_search.traineds && this.info_search.traineds.length > 0) {
				      		info.traineds = this.info_search.traineds; //.map(x => x.userId);
				      	}
				      	
				      	if (this.info_search.speed) {
				      		info.speed = this.info_search.speed;
				      	}
			    		this.message_export = this.$ml.get("consulting_information");				      	
				        // request reports
			    		this.message_export = this.$ml.get("lpr");				      					        
				        const rowsLpr = await this.$axios.post(this.$URL+'/api/v1/lpr/report', info);			
				        if (this.info_search.search) { info.vehicle_type = this.info_search.search; }
			    		this.message_export = this.$ml.get("avc");				      					        
				        const rowsAvc = await this.$axios.post(this.$URL+'/api/v1/avc/report', info);			       
			    		this.message_export = this.$ml.get("alarms");				      					        
				     	const rowsAlarm = await this.$axios.post(this.$URL+'/api/v1/alerts/report', info);				    		
			    		this.message_export = this.$ml.get("smart_event");				      					        
				     	const rowsSmartEvent = await this.$axios.post(this.$URL+'/api/v1/smart_event/report', info);        	
			    		this.message_export = this.$ml.get("face");				      					        
					    const rowsFace = await this.$axios.post(this.$URL+'/api/v1/face/find/report', info);
					    if(this.info_search.plate_char) {info.plate_char 	= this.info_search.plate_char; }
				        // const rowsParking = this.$axios.post(this.$URL+'/api/v1/parking/report', info);
				        // exporting data
			    		this.message_export = this.$ml.get("adding_to_excel");		

				        const listLPR = await this.renderToExcel(rowsLpr, "lpr");
				        console.log("LPR await ", listLPR)
				        const listAvc = await this.renderToExcel(rowsAvc, "avc");
				        const listAlarm = await this.renderToExcel(rowsAlarm, "alarms");
				        const listSmartEvent = await this.renderToExcel(rowsSmartEvent, "smart_event");
				        const listFace = await this.renderToExcel(rowsFace, "face");
				        // const listParking = await this.renderToExcel(rowsParking.rows, "parking");				        

				        // format to excel
			    		this.message_export = this.$ml.get("adding_to_excel");				      					        				        	
				        const workbook = await this.$Format.create_workbook_excel_async();
				        const mlReport = this.$ml.get('reports');
				        
				        await this.$Format.add_sheet_for_excel_async(workbook, mlReport,[
				        	{ 
				        		[mlReport] : this.$ml.get('consultation_date'), 
				        		"" : this.$Format.format_date(new Date(), "createdAt", "YYYY-MM-DD HH:mm ss")
				        	},
				        	{
				        		[mlReport] : this.$ml.get("date_range"),
				        		"" :  `${info.start} - ${info.end}`
				        	},
				        	{
				        		[mlReport] : this.$ml.get("lpr"),
				        		"" : listLPR.length
				        	},
				        	{
				        		[mlReport] : this.$ml.get("avc"),
				        		"" : listAvc.length
				        	},
				        	{
				        		[mlReport] : this.$ml.get("alarms"),
				        		"" : listAlarm.length
				        	},
				        	{
				        		[mlReport] : this.$ml.get("smart_event"),
				        		"" : listSmartEvent.length
				        	},
				        	{
				        		[mlReport] : this.$ml.get("face"),
				        		"" : listFace.length
				        	},
				        	/*{
				        		[mlReport] : this.$ml.get("parking"),
				        		"" : listParking.length
				        	},*/
				        ]);
				        await this.$Format.add_sheet_for_excel_async(workbook, this.$ml.get("lpr"), listLPR)
				        if (listAvc && listAvc.length > 0) await this.$Format.add_sheet_for_excel_async(workbook, this.$ml.get("avc"), listAvc);
				        if (listAlarm && listAlarm.length > 0) await this.$Format.add_sheet_for_excel_async(workbook, this.$ml.get("alarms"), listAlarm);
				        if (listSmartEvent && listSmartEvent.length > 0) await this.$Format.add_sheet_for_excel_async(workbook, this.$ml.get("smart_event"), listSmartEvent);
				        if (listFace && listFace.length > 0) await this.$Format.add_sheet_for_excel_async(workbook, this.$ml.get("face"), listFace);
				        // if (listParking && listParking.length > 0) await this.$Format.add_sheet_for_excel_async(workbook, this.$ml.get("parking"), listParking);
			    		this.message_export = this.$ml.get("downloading_report");				      					        				        


				        // Download the excel
				        await this.$Format.download_excel_async(workbook, "All_report");
			     		this.message_export = "";
			     		this.loading_export = false;				        
				        
			    }else{
			      		console.log("Not found device to search");
			      		this.loading_export = false;
				        this.message_export = "";
			      		
			      		this.$EventBus.$emit('notifications_modal', {
			      			type 	: 'warning',
			      			message : this.$ml.get('req_sel_device')
			      		});
			      	}

		    	}catch(error){
		    		console.warn("Error exportExcelAll ", error)
			     	this.loading_export = false;
		    	}

		    }, // exportExcelAll	

		  	onChange(input) {
            	this.input = input;
            	this.info.plate_char = input.toUpperCase();
          	},
          	onKeyPress(button) {
            	// console.log("button", button);
            	if(button=='{enter}'){
              		this.search_data(true);
            	}
          	},
	        onInputChange(input) {
	            this.input = input.target.value;
	            // this.search=input;
	        },

	        keyboard_is_active(){
	            let key_board = false;
	            if (localStorage.getItem('virtual_Key_board')) {
	            	key_board = JSON.parse(localStorage.getItem('virtual_Key_board'));
	         	}         
	            if (key_board == true) {
	              this.sheet = true;            
	            }
	        },  // keyboard is active
		}, // methods


		mounted(){
			let temp_bus = 'keyboard_type' + this.ID_notification;
			EventBus.$on(temp_bus, this.bus[temp_bus] =  (action) =>{
				if (action) {
					console.log("INPUT TYPE : ",action.input, action.setting)
					if (action.setting) {
						let { obj, key, type } =  action.setting;
						if (type == 'text') {
							this[key] = action.input;
						}else{
							if (key == 'plate_char') {
								this[obj][key] = action.input.toUpperCase();
								this.input 	   = action.input.toUpperCase();
							}else{
								this[obj][key] = action.input;
								this.input 	   = action.input;
							}
						}
					}
				}
			});

			let bus_keyboard = "update_table_" + 'management_events_' + this.ref; 
			EventBus.$on(bus_keyboard , this.bus[bus_keyboard] = (action) =>{						
				if (action && action.id) {
					if (this.report_items && this.report_items.length > 0) {						
						let idx = this.report_items.findIndex( x => (x && x.id == action.id));					
						if (idx >= 0) {
							this.report_items[idx] = { ...this.report_items[idx], ...action };
							if (this.report_items[idx] && this.report_items[idx].formated) {
								this.report_items[idx].formated = { ...this.report_items[idx].formated, ...action };
							} 				
							this.report_items.splice(idx, 1, this.report_items[idx]);
						}
					}
				}
			})
			
		}, // mounted

		beforeDestroy(){			
			this.$Helper.clear_bus(EventBus, this.bus, 'reports_lpr');
		}, // beforeDestroy

	}; // export default
</script>
